// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-flux .flux-caption{flex:none;width:100%;font-size:.8rem;line-height:1.1rem;padding:6px;box-sizing:border-box;color:#fff;text-align:center;background-color:rgba(0,0,0,.65);opacity:0}.vue-flux .flux-caption.visible{opacity:1;transition:opacity .3s ease-in}", ""]);
// Exports
module.exports = exports;
